import { useEffect } from 'react';
import { useNavigate } from 'react-router';

interface ServiceWorkerNavigationMessage {
  type: 'NAVIGATE_TO';
  url: string;
  timestamp: number;
}

export function useServiceWorkerNavigation() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    const handleMessage = (event: MessageEvent<ServiceWorkerNavigationMessage>) => {
      if (event.data && event.data.type === 'NAVIGATE_TO') {
        const { url } = event.data;

        navigate(url);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
    };
  }, [navigate]);
}
